import { useEffect, useRef } from "react";
import type { FC } from "react";
import { mountReading } from "./effects";
import type { Effect } from "./effects";

interface Props {
  src: string;
  depth: string;
  effect: Effect;
  className?: string;
}

/** A still picture drawn as one moving reading of itself, filling its box like `object-fit: cover`. */
export const Reading: FC<Props> = ({ src, depth, effect, className }) => {
  const ref = useRef<HTMLCanvasElement>(null);
  const now = useRef(effect);

  useEffect(() => {
    now.current = effect;
  }, [effect]);

  useEffect(() => {
    if (!ref.current) return;
    return mountReading(ref.current, { src, depth, effect: () => now.current });
  }, [src, depth]);

  return <canvas ref={ref} aria-hidden className={className} />;
};
